module.exports = {
      id: "icon-clinic-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-clinic",
      toString: function () {
        return this.url;
      }
    }